import React from "react";
import { AutoComplete, Button, Input, DatePicker, Badge, Form, Popconfirm } from "antd";
import {
  ContributorsAutoCompleteApi,
  fetchMode,
  getPostContributionApi, deleteContributionApi
} from "../../services/apiService";
import { showApiError} from "../utilities";
import { record_operation } from "../enums";
import "moment/locale/en-nz";
import moment from "moment";
import ContributionLines from "./ContributionLines";
import debounce from "lodash.debounce";

//const waitTime = 250;

class ContributionDetails extends React.Component {
  constructor(props) {
    super(props);
    this.newEntry = true
    this.AllowEditMember = true
    let contribution 
    if (this.props.contribution) {
      contribution = this.props.contribution;
      this.newEntry = this.props.contribution.contributionId < 0
      this.AllowEditMember = this.props.contribution.contributorId < 1
    } else {
      contribution = {};
    }
    this.state = {
      memberList: [],
      selectedMember: "",
      offeringNo: "",
      contributorId: this.props.contributorId,
      contribution: contribution
    };

    this.debounceLoadData = debounce(this.loadData, 200);
    this.debounceAutoPick = debounce(this.autopick, 220);
    this.handleRowUpdate = this.handleRowUpdate.bind(this);
  }

  handleOnSelect = selectedValue => {
    //console.log("selectedValue: " + selectedValue);
    let member = this.state.memberList.find(
      member => member.value === parseInt(selectedValue)
    );
    this.setMember(member);
    //console.log(member);
  };

  handleOnChange = changedValue => {
    //console.log("changedValue:" + changedValue);
    //this.setState({ contributorId: changedValue });
  };

  handleSearch = searchValue => {
    //console.log("do Search.." + searchValue);
    this.debounceLoadData(searchValue);
    this.setState({ selectedMember: searchValue, offeringNo: "" });
    //this.loadData(searchValue)
  };

  handleOnFocus = e => {
    this.setState({ memberList: [] });
  };

  handleOnBlur = e => {
    //console.log("onBlur:" + e);
    if (this.state.offeringNo === "") {
      this.debounceAutoPick();
    }
  };

  onDateChange = e => {

    let contribution = this.state.contribution 
    contribution.contributionDate = moment(e).format("YYYY-MM-DD");

    this.setState({ contribution: contribution } )
    //this.contribution.contributionDate = moment(e).format("YYYY-MM-DD"); // date part only;
  };

  handleSave = () => {
    //console.log("saving contrbution...");
    let savingContribution = this.getSavingContribution();
    let validatedMessage = this.validateSavingContribution(savingContribution);
    if (validatedMessage === "") {
      this.doSave(savingContribution);
    } else {
      showApiError(validatedMessage);
    }
  };

  handleDelete = () => {
    //console.log(`deleting contribution Id ${this.state.contribution.contributionId}`);
    this.doDelete() 
  };

  handleRowUpdate = rowData => {
    //console.log("handledRowUpdate rowdata: ");
    let contributionLines = this.state.contribution.contributionLines.slice();
    let found = false;
    for (let index = 0; index < contributionLines.length; index++) {
      let line = contributionLines[index];
      if (line.contributionLineId === rowData.contributionLineId) {
        line = { ...line, ...rowData };
        contributionLines[index] = line;
        found = true;
        break;
      }
    }
    if (!found) {
      contributionLines.push(rowData);
    }
    //this.contribution.contributionLines = contributionLines;

    let contribution = this.state.contribution 
    contribution.contributionLines = contributionLines
    //console.log("row update ")
    //console.log(contribution);
    this.setState({ contribution })

    //console.log("contributionDetails.handlerowUpdate")
    return contributionLines.reduce((total, p) => total + (p.amount || 0), 0)
  };

  render() {
    //console.log('new entry: ' + this.newEntry)
    let { contributionLines } = this.state.contribution;
    let memberList = this.state.memberList;
    let selectedMember = null;
    //let newEntry = true;
    let offeringNo = "";
    if (!this.AllowEditMember) {
      //console.log( 'Not AllowEditMember ' )
      let value = this.state.contribution.offeringNo;
      let text = this.state.contribution.displayName;
      offeringNo = value;
      memberList = [
        {
          value: value,
          text: text
        }
      ];
      selectedMember = text;
      //newEntry = false;
    } else {
      //console.log('selectedMember: ' + this.state.selectedMember )
      selectedMember = this.state.selectedMember;
      offeringNo = this.state.offeringNo;
    }

    const dateFormat = "DD-MM-YYYY";
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };


    return (
      <Form autoComplete="nope" className="side-form">
        <div className="panel" style={{ padding: 10 }}>
          <h4>Contribution</h4>
        </div>
        <Form.Item {...formItemLayout} label="Date">
          <DatePicker
            allowClear={false}
            autoFocus={true}
            defaultValue={moment(this.props.contributionDate)}
            format={dateFormat}
            onChange={this.onDateChange}
          />
        </Form.Item>
        <Form.Item {...formItemLayout} label="Member">
          <AutoComplete
            style={{ width: "85%" }}
            backfill={false}
            dataSource={memberList}
            onSearch={this.handleSearch}
            onChange={this.handleOnChange}
            onSelect={this.handleOnSelect}
            onBlur={this.handleOnBlur}
            defaultValue={selectedMember}
            value={selectedMember}
            optionLabelProp="value"
            disabled={!this.AllowEditMember}
          >
            <Input onFocus={this.handleOnFocus} />
          </AutoComplete>{" "}
          <Badge
            count={offeringNo}
            showZero
            style={{
              backgroundColor: "#fff",
              color: "#999",
              boxShadow: "0 0 0 1px #d9d9d9 inset"
            }}
            overflowCount={10000}
          />
        </Form.Item>
        <ContributionLines
          funds={this.props.funds}
          lines={contributionLines}
          contributionId={this.state.contribution.contributionId}
          rowUpdate={this.handleRowUpdate}
        />
        <Form.Item wrapperCol={{ span: 24, offset: 1 }}>
          <Button icon="save" type="primary" onClick={this.handleSave} style={{ margin: '0px 5px 0px 0px' }}>
            Save
          </Button>
          <Popconfirm
            title="Are you sure delete this contributor?"
            onConfirm={this.handleDelete}
            okText="Yes"
            cancelText="No">
            <Button icon="delete" disabled={this.newEntry} type="danger">Delete</Button>{" "}
            </Popconfirm>
        </Form.Item>
      </Form>
    );
  }

  // class helper functions
  autopick = () => {
    // fill the offering number using the return autocomplete array if nothing has pick
    // this is the case when user enter an offering number an then tab out without selecting anything
    let member;
    if (this.state.memberList.length > 0) {
      member = this.state.memberList[0];
      let selectedMember = member.text.substr(member.text.indexOf(" ") + 1);
      let offeringNo = member.text.substr(0, member.text.indexOf(" "));
      this.setState({ selectedMember, offeringNo, contributorId: member.id });
    }
    this.setMember(member);
  };

  setMember = member => {
    let offeringNo = "";
    let selectedMember = "";
    let contributorId = -1;
    if (member) {
      selectedMember = member.text.substr(member.text.indexOf(" ") + 1);
      offeringNo = member.text.substr(0, member.text.indexOf(" "));
      contributorId = member.id;
    }

    let contribution = this.state.contribution 
    contribution.contributorId = contributorId;
    contribution.offeringNo = offeringNo;
    this.setState({ selectedMember, offeringNo, contributorId, contribution });
  };

  loadData(qString) {
    ContributorsAutoCompleteApi(qString)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          if (fetchMode === "local") {
            //console.log("localmode, local process");
            json = this.localPostProcess(qString, json);
          }
          this.setState({
            memberList: json
          });
        }
      })
      .catch(error => {
        showApiError(error);
      });
  }

  // this function only use for local development to simulate the autocomplete search
  // it won't be use in production
  localPostProcess(str, members) {
    function byValue(search) {
      return function(element) {
        if (element.value === parseInt(search)) {
          return element;
        }
      };
    }

    function byName(search) {
      return function(element) {
        if (element.text.toLowerCase().includes(search.toLowerCase())) {
          return element;
        }
      };
    }

    if (isNaN(str)) {
      return members.filter(byName(str));
    } else {
      return members.filter(byValue(str));
    }
  }

  doDelete = () => {
    let dstring = moment(this.state.contribution.contributionDate ).format("YYYYMMDD")    
    //let dstring = this.contribution.contributionDate 
    deleteContributionApi(this.state.contribution.contributionId, dstring) 
    .then(json => {
      if (typeof json === "string") {
        throw new Error(json);
      } else {
        this.props.postSave(
          json,
          record_operation.DELETE
        );
      }
    })
    .catch(error => {
      showApiError(error);
    });
  } 

  doSave = contribution => {
    //do something here,
    let operation;
    if (contribution.contributionId > 0) {
      operation = record_operation.UPDATE;
    } else {
      operation = record_operation.ADD;
    }
    getPostContributionApi(contribution)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          this.props.postSave(
            json,
            operation
          );
        }
      })
      .catch(error => {
        showApiError(error);
      });
  };
  validateSavingContribution(contribution) {
    let result = "";
    if (parseInt(contribution.contributorId) < 0) {
      result = "Member cannot be blank.";
    }
    if (contribution.contributionLines.length === 0) {
      result = "Nothing to save.";
    }
    return result;
  }

  getSavingContribution = () => {
    //remove empty lines
    let lines = this.state.contribution.contributionLines
      .filter(line => {
        return (
          line.contributionLineId > 0 ||
          (line.contributionLineId < 0 && parseFloat(line.amount) > 0 && (line.fund && line.fund.trim().length > 0) )
        );
      })
      .map(ln => {
        let updatedline = { ...ln }; // clone the line instead of reference it
        if (updatedline.contributionLineId < 0) {
          updatedline.contributionLineId = 0;
        }
        return updatedline;
      });

    let savingContribution = { ...this.state.contribution, contributionLines: lines }; // clone to object
    if (savingContribution.contributionId < 0) {
      savingContribution.contributionId = 0;
    }
    return savingContribution;
  };
}

export default ContributionDetails;
